import { createFileRoute, type SearchSchemaInput } from "@tanstack/react-router"
import { z } from "zod"

const billingsSchema = z.object({
  facilities: z.array(z.coerce.number()).optional().catch(undefined),
})

export const Route = createFileRoute("/_app/reports/billing/")({
  validateSearch: (search: SearchSchemaInput) => billingsSchema.parse(search),
})
